"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowMoreContent = exports.ShowMoreButton = exports.ShowMore = void 0;
var _react = _interopRequireWildcard(require("react"));
var _IconDownCaret = _interopRequireDefault(require("../../elements/icons/IconDownCaret"));
/**
 * A component that shows hidden content when a button is clicked.
 *
 * Inside the <ShowMore> component, supply a <ShowMoreButton> and a <Content> containing the content to be shown.
 * Clicking the ShowMoreButton will reveal the content. You can supply an onClick handler to perform additional tasks.
 * The <Content> component can be optional this situation.
 */

const ShowMoreContext = /*#__PURE__*/(0, _react.createContext)({
  shown: false,
  toggle: () => {}
});
ShowMoreContext.displayName = 'ShowMoreContext';
const useShowMore = () => {
  const context = (0, _react.useContext)(ShowMoreContext);
  if (context === undefined) {
    throw new Error('useShowMore must be used within a ShowMoreContext provider');
  }
  return context;
};

// The content to be shown/hidden
const ShowMoreContent = _ref => {
  let {
    children
  } = _ref;
  const {
    shown
  } = useShowMore();
  return shown ? children : null;
};

// onClick is an optional function to be called when the ShowMoreButton is clicked.
exports.ShowMoreContent = ShowMoreContent;
const ShowMoreButton = _ref2 => {
  let {
    children,
    onClick,
    ...props
  } = _ref2;
  const {
    shown,
    toggle
  } = useShowMore();
  const handleEvents = () => {
    toggle();
    // @ts-ignore
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };
  return /*#__PURE__*/_react.default.createElement("button", {
    className: props.className,
    style: {
      color: props === null || props === void 0 ? void 0 : props.color
    },
    type: "button",
    onClick: handleEvents
  }, children, /*#__PURE__*/_react.default.createElement(_IconDownCaret.default, Object.assign({
    color: props.color,
    upsideDown: shown
  }, props)));
};

// Container for ShowMoreButton and ShowMoreContent
exports.ShowMoreButton = ShowMoreButton;
const ShowMore = _ref3 => {
  let {
    children
  } = _ref3;
  const [shown, setShown] = (0, _react.useState)(false);
  const toggle = () => {
    setShown(!shown);
  };
  return /*#__PURE__*/_react.default.createElement(ShowMoreContext.Provider, {
    value: {
      shown,
      toggle
    }
  }, children);
};
exports.ShowMore = ShowMore;